











import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'search-result-suggested-categories',
})

export default class extends Vue {
  @Prop() private resultData: Array<object>;
  @Prop() private searchQuery: String;

  private getLabel(label): string {
    return label.toLowerCase().replace(/\s/g, '&nbsp;').replace(this.searchQuery.toLowerCase(), `<b>${this.searchQuery.toLowerCase()}</b>`);
  }
}


